var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBanana = function SvgBanana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1.82 7.27c.28 0 1.48.41 2.96 1.14 1.48.74 3.36 1.92 5.8 1.15 2.08-.55 4.16-3.11 4.16-3.11s.38-1.06.26-3.67c.52-1.37 1.64-.57 1.9-.31.1.1.28.64-.44 1.6-.72.96-.12 2.74-.12 2.74s1.28 2.88-2.12 5.58c-2.58 2.05-5.64 1.88-5.64 1.88s-4.97.52-7.28-5.08c-.64-1.55-.16-1.92.52-1.92Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBanana;